import { Registerable } from '@baserow/modules/core/registry'
import MadeWithBaserowBuilderDecorator from '@baserow_enterprise/components/builder/MadeWithBaserowBuilderDecorator'

/**
 * The BuilderPageDecorator type serves as a wrapper component that can be
 * registered and applied around page content in published builder apps.
 */
export class BuilderPageDecoratorType extends Registerable {
  /**
   * Must return a string containing the type of the decorator.
   */
  static getType() {
    throw new Error('Must be set by the implementing subclass.')
  }

  /**
   * Component that will be rendered to wrap the page content.
   * The component must use a slot to render the wrapped content.
   */
  get component() {
    throw new Error('Must be set by the implementing subclass')
  }

  /**
   * Returns whether the decorator should be applied for the current context.
   * This is called to determine if the decorator should be applied to the page.
   */
  isDecorationAllowed(workspace = {}) {
    return true
  }

  /**
   * Should return an object with props to pass to the component.
   */
  getProps() {
    return {}
  }
}

/**
 * Upstream uses this decorator to stamp a "Made with Baserow" badge onto the
 * bottom right of published builder pages whenever the workspace lacks an
 * Enterprise/Advanced license.
 *
 * This deployment serves its own brand and never shows that badge, so the
 * decoration is switched off unconditionally rather than gated on
 * `BUILDER_NO_BRANDING`. The type itself is kept registered so the decorator
 * registry, and any upstream changes to it, keep merging cleanly.
 */
export class MadeWithBaserowBuilderPageDecoratorType extends BuilderPageDecoratorType {
  static getType() {
    return 'made_with_baserow'
  }

  get component() {
    return MadeWithBaserowBuilderDecorator
  }

  isDecorationAllowed(workspace = {}) {
    return false
  }
}
